{
    "NAME": "Visão geral do administradorIdioma",
    "AdminOverview_Intro": "Selecione um CME, um servidor de telefonia e uma partição para visualizar as áreas administrativas disponíveis e as contagens atuais.",
    "AdminOverview_Search_Helper": "A pesquisa aplica-se às contagens aqui apresentadas e estende-se à página administrativa selecionada.",
    "AdminOverview_State_Loading": "Carregando",
    "AdminOverview_State_Error": "Não foi possível carregar a contagem mais recente.",
    "AdminOverview_State_NoTelephonyServer": "Nenhum servidor de telefonia incluído no escopo",
    "AdminOverview_State_SelectTelephonyServer": "Selecione um servidor de telefonia para carregar esta contagem.",
    "AdminOverview_State_SelectTelephonyServerAndPartition": "Selecione um servidor de telefonia e uma partição para carregar essa contagem.",
    "AdminOverview_State_SelectPartition": "Selecione uma partição específica para visualizar essa contagem.",
    "AdminOverview_State_MessagesLegacy": "Página de administração legada",
    "AdminOverview_State_DatabaseLegacy": "Página de administração legada",
    "AdminOverview_Tile_Cme_Title": "CMEs",
    "AdminOverview_Tile_Cme_Subtitle": "Estrutura de serviço",
    "AdminOverview_Tile_Cme_Summary": "Educação Médica Continuada para Crianças",
    "AdminOverview_Tile_Cme_Aria": "Educação Médica Continuada Aberta",
    "AdminOverview_Tile_Telsys_Title": "Servidores de telefonia",
    "AdminOverview_Tile_Telsys_Subtitle": "Propriedade da plataforma",
    "AdminOverview_Tile_Telsys_Summary": "Total de servidores",
    "AdminOverview_Tile_Telsys_Aria": "Servidores de telefonia abertos",
    "AdminOverview_Tile_Partitions_Title": "Partições",
    "AdminOverview_Tile_Partitions_Subtitle": "Escopo da partição",
    "AdminOverview_Tile_Partitions_Summary": "Partições",
    "AdminOverview_Tile_Partitions_Aria": "Partições abertas",
    "AdminOverview_Tile_Users_Title": "Usuários",
    "AdminOverview_Tile_Users_Subtitle": "Acesso ao aplicativo",
    "AdminOverview_Tile_Users_Summary": "Usuários",
    "AdminOverview_Tile_Users_Aria": "Usuários abertos",
    "AdminOverview_Tile_Devices_Title": "Dispositivos",
    "AdminOverview_Tile_Devices_Subtitle": "Inventário de endpoints",
    "AdminOverview_Tile_Devices_Summary": "Dispositivos",
    "AdminOverview_Tile_Devices_Aria": "Dispositivos abertos",
    "AdminOverview_Tile_Devices_Extension": "Extensão",
    "AdminOverview_Tile_Devices_ExtensionTrunking": "Extensão (Tronco)",
    "AdminOverview_Tile_Devices_ExtensionHospitality": "Extensão (Hospitalidade)",
    "AdminOverview_Tile_Devices_Groups": "Grupos",
    "AdminOverview_Tile_Devices_AutoAttendant": "Atendente automático",
    "AdminOverview_Tile_Agents_Title": "Agentes",
    "AdminOverview_Tile_Agents_Subtitle": "Operações de fila",
    "AdminOverview_Tile_Agents_Summary": "Agentes",
    "AdminOverview_Tile_Agents_Aria": "Agentes Abertos",
    "AdminOverview_Tile_Directory_Title": "Diretório",
    "AdminOverview_Tile_Directory_Subtitle": "Registros de contato",
    "AdminOverview_Tile_Directory_Summary": "Diretórios",
    "AdminOverview_Tile_Directory_Aria": "Diretório Aberto",
    "AdminOverview_Tile_Codes_Title": "Códigos",
    "AdminOverview_Tile_Codes_Subtitle": "Gerenciamento de código",
    "AdminOverview_Tile_Codes_Summary": "Códigos",
    "AdminOverview_Tile_Codes_Aria": "Códigos abertos",
    "AdminOverview_Tile_Recording_Title": "Gravação",
    "AdminOverview_Tile_Recording_Subtitle": "Integrações",
    "AdminOverview_Tile_Recording_Summary": "Gravações",
    "AdminOverview_Tile_Recording_Aria": "Gravação aberta",
    "AdminOverview_Tile_Messages_Title": "Mensagens",
    "AdminOverview_Tile_Messages_Subtitle": "Ferramentas legadas",
    "AdminOverview_Tile_Messages_Aria": "Abrir mensagens",
    "AdminOverview_Tile_Database_Title": "Banco de dados",
    "AdminOverview_Tile_Database_Subtitle": "Ferramentas legadas",
    "AdminOverview_Tile_Database_Aria": "Banco de dados aberto"
}